<div>
  <div class="mb-4">
    For your own benefit and protection, please read the
    <a
      class="link"
      target="_blank"
      href="cms_data/pdfs/sky-protect-plus-policy-terms.pdf"
      title="Terms & Conditions"
      >Sky+ HD Protect Policy Terms and Conditions</a
    >, and the
    <a
      class="link"
      target="_blank"
      href="cms_data/pdfs/SKY_Protect_IPID_Web.pdf"
      title="Insurance Product Information Document"
      >Sky+ HD Insurance Product Information Document</a
    >
    and that this product meets your demands and needs.
  </div>
  <div class="form-group form-group--checkbox">
    <div [formGroup]="formGroup">
      <dgx-dfb-checkbox
        [formControlName]="field.controlName"
        [field]="field"
      ></dgx-dfb-checkbox>
    </div>
  </div>
</div>
